/* 
* title -> string = título para o componente PageTitle
* subtitle -> string = subtítulo para o componente PageTitle
* primaryColor -> string = cor do título para o componente PageTitle
* primaryColor -> string = cor do subtítulo para o componente PageTitle
* dividerColor -> string = cor da linha divisória para o componente PageTitle
*
*
* content -> string = conteúdo informativo principal do card
*
*
* label -> string = nome do botão para o componente Btn
* type -> string = tipo de botão para o componente Btn
* textColor -> string = cor do texto do botão para o componente Btn
* iconName -> string = nome do icone conteúdo contigo dentro do espaço do botão para o componente Btn
* _function -> função = função aplicada ao componente Btn
* routeCard -> string = caminho/rota de direcionamento do link para página
*/

import { useNavigate } from 'react-router-dom';
import PageTitle from "../PageTitle/PageTitle";
import Btn from "../Btn/Btn"
import './CardProfile.css'

const CardProfile = (props) => {
    const { title, subtitle, content, primaryColor, secondaryColor, dividerColor, textColor, label, iconName, routeCard } = props
    const navigate = useNavigate()

    return (
        <div className="container-card-profile w-box-shadow-black">
            <div className="container-card-profile-title">
                <PageTitle title={title} subtitle={subtitle} primaryColor={primaryColor} secondaryColor={secondaryColor} dividerColor={dividerColor} />
            </div>
            <div className="container-card-profile-content">
                <span className="white100">{content}</span>
            </div>
            <div className="container-card-profile-btn">
                <Btn label={label} type={'link'} textColor={textColor} iconName={iconName} _function={() => navigate(routeCard)}/>
            </div>
        </div>
    )
}

export default CardProfile;